import React from 'react'

import { TotalSampleTag } from '../components/chart-segment/selection-scope'
import { TextClamp } from '../components/text/TextClamp'
import { QuoteListPlot, readSlideQuoteCard, StoredSlideQuoteCard } from '../plots/quote-list'

const LINE = 'var(--slide-border-soft)'

export interface SlideQuoteCardProps {
  quoteCard: StoredSlideQuoteCard
  /** The slide's own test id for the card frame (kept from the inline cards). */
  testId: string
  renderMode?: 'interactive' | 'static'
}

/**
 * The bar slides' quote card (single-select, multi-select, ranking), plots
 * plan S: the frame and the stored header band are slide chrome, the body is
 * the `quote-list` plot in its `card` layout. Same DOM order, styles and test
 * ids as the three inline copies it replaces.
 *
 * The header band holds the card's title and stat. Choice cards no longer
 * carry either (a winner label beside someone else's quote was a claim
 * nothing backed), so the band shows only on decks stored with them, and an
 * empty band and its divider collapse.
 */
export function SlideQuoteCard(props: SlideQuoteCardProps) {
  const { quoteCard, testId, renderMode } = props

  const hasHeader = Boolean(quoteCard.title?.trim() || quoteCard.stat?.trim())
  const plot = readSlideQuoteCard(quoteCard)

  const header = hasHeader ? (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 16 }}>
        <TextClamp minLines={1} maxLines={1} lineHeight="1.4" style={{ fontSize: 18, fontWeight: 600, color: 'var(--slide-text-primary)' }}>
          {quoteCard.title || ''}
        </TextClamp>
        <TotalSampleTag />
        {quoteCard.stat ? (
          <div style={{ borderRadius: 30, padding: '2px 12px', background: 'var(--slide-accent-soft)', color: 'var(--slide-cover-bg)', fontSize: 16, fontWeight: 500, whiteSpace: 'nowrap' }}>
            {quoteCard.stat}
          </div>
        ) : null}
      </div>
      <div style={{ height: 1, background: LINE, margin: '12px 0' }} />
    </>
  ) : null

  return (
    <div
      data-testid={testId}
      style={{ border: `1px solid ${LINE}`, borderRadius: 16, padding: 20, minHeight: hasHeader ? 178 : undefined, boxSizing: 'border-box' }}
    >
      {header}
      <QuoteListPlot data={plot.data} size="slide" layout="card" renderMode={renderMode} />
    </div>
  )
}
